import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import Header from './components/Header';
import Tabs from './components/Tabs';
import {
  Wrapper, DetailWrapper, ResizerWrapper,
  Resizer, Transparency, ModalWrapper
} from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/styled';
import { useResizeX } from 'Hooks/useResize';
import useWindowDimensions from 'Hooks/useWindowSize';
import useShortcutScope from 'Hooks/useShortcutScope';
import useFormShortcuts from 'Hooks/useFormShortcuts';
import ImagePreviewModal from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/ImagePreviewModal';
import TabSelector from './components/Tabs/components/TabSelector';
import { selectShowTagsModal } from 'store/Tags/selectors';
import { selectShowDetail, selectVulnDetailId, selectVulnDetailTags, selectVulnsSelected } from 'store/ManageGeneral/selectors';
import { redirectToVulnerabilities } from 'store/ManageGeneral/actions';
import CreateEditTagsModal from './components/CreateEditTagsModal';
import IntegrationsModals from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/IntegrationsModals';
import Warning from 'Common/Components/Warning';
import { resetWarning } from 'store/Settings/settingsActions';
import { useIntl } from 'react-intl';

const VulnerabilityDetail = () => {
  const [showTransparency, setShowTransparency] = useState(false);
  const ref = useRef(null);
  const wrapperRef = useRef(null);
  const resizerRef = useRef(null);
  const { width } = useWindowDimensions();
  const minWidth = width < 3000 ? width * 0.55 : width * 0.35;
  const maxWidth = width < 3000 ? width * 0.75 : width * 0.55;
  const wrapperWidth = useResizeX(wrapperRef, resizerRef, minWidth, minWidth, maxWidth);
  const showCreateTagModal = useSelector((state) => selectShowTagsModal('vulnDetail', state));
  const vulnsTags = useSelector(selectVulnDetailTags);
  const intl = useIntl();
  const error = useSelector((state) => get(state, 'settings.sendVulnToTool.payload.error', false));
  const message = useSelector((state) => get(state, 'settings.sendVulnToTool.payload.message', ''));
  const dispatch = useDispatch();
  const isVulnDetailOpen = useSelector(selectShowDetail);
  const vulnId = useSelector(selectVulnDetailId);
  const vulnsSelected = useSelector(selectVulnsSelected);
  const shortcutScope = useShortcutScope('vuln-detail');

  const handleClose = () => dispatch(redirectToVulnerabilities());

  useFormShortcuts({ onCancel: handleClose, scope: shortcutScope, cancelLabel: 'Close' });

  const onScroll = () => {
    const scrollTop = get(ref, 'current.scrollTop', 0);
    if (scrollTop === 0) setShowTransparency(false);
    else setShowTransparency(true);
  };

  return (
    <>
      <ImagePreviewModal />
      { showCreateTagModal && <CreateEditTagsModal vulnsTags={ vulnsTags } entity="vulnDetail" /> }
      <IntegrationsModals vulnsSelected={ vulnsSelected } vulnId={ vulnId } isVulnDetailOpen={ isVulnDetailOpen } entity="vulnsGeneral" />
      {error && message &&
      <ModalWrapper>
       <Warning
         title={ intl.formatMessage({ id: 'sendToTool.warnings.oops.title' }) }
         onClose={ () => dispatch(resetWarning()) }
       >
            {message}
       </Warning>
      </ModalWrapper>
          }
      <Wrapper ref={ wrapperRef } wrapperWidth={ wrapperWidth }>
        <ResizerWrapper ref={ resizerRef } children={ <Resizer /> } />
        <DetailWrapper>
          <Header onClose={ handleClose } />
          <TabSelector scope={ shortcutScope } />
          { showTransparency && <Transparency /> }
          <Tabs tabRef={ ref } onScroll={ onScroll } showTransparency={ showTransparency } />
        </DetailWrapper>
      </Wrapper>
    </>
  );
};

export default VulnerabilityDetail;
